import { Amenity } from '../models/amenity.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';
import { httpService } from './httpService';

class AmenityService extends GenericService<Amenity, ListItem> {
  constructor() {
    super('/api/Amenity');
  }
  async getAmenitiesByPropertyId(propertyId: number | string): Promise<Amenity> {
    return await httpService.get<Amenity>(`/api/Amenity/GetByPropertyId/${propertyId}`, undefined, { unwrap: true, normalize: true, toast: false, });
  }
  async getParentAmenities(): Promise<Amenity[]> {
    return await httpService.get<Amenity[]>('/api/Amenity/GetParentAmenities', undefined, { unwrap: true, normalize: true, toast: false });
  }

  async getChildAmenitiesByParentId(parentAmenityId: number | string): Promise<Amenity[]> {
    return await httpService.get<Amenity[]>(`/api/Amenity/GetChildAmenitiesByParentId/${parentAmenityId}`, undefined, { unwrap: true, normalize: true, toast: false });
  }

  async getAllAmenities(): Promise<Amenity[]> {
    return await httpService.get<Amenity[]>('/api/Amenity/GetAll', undefined, { unwrap: true, normalize: true, toast: false });
  }
}
export const amenityService = new AmenityService();